import script from "./VinificationStep.vue?vue&type=script&setup=true&lang=js"
export * from "./VinificationStep.vue?vue&type=script&setup=true&lang=js"

import "./VinificationStep.vue?vue&type=style&index=0&id=3cb8b6ef&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3cb8b6ef"]])

export default __exports__